import React from "react";
import { Star } from "lucide-react";

const testimonials = [
    { name: "Ananya S.", city: "Kolkata", type: "2 BHK Apartment", rating: 5, text: "Set-up was done in under an hour and I didn't need to change a single fan or light. My old AC now listens to Alexa." },
    { name: "Rohit M.", city: "Gurugram", type: "3 BHK Villa", rating: 5, text: "Comparable luxury setups were 4× the cost. GoSmartNest gave me the same experience for a fraction of the price." },
    { name: "Meera K.", city: "Bhubaneswar", type: "2 BHK Apartment", rating: 5, text: "The 'Good Night' scene is my favourite — one command, everything shuts down and the door locks itself." },
];

export default function Testimonials() {
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="testimonials">
            <div className="flex items-end justify-between gap-6 mb-10 flex-wrap">
                <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-[#1BB6F0] font-semibold">Customer stories</div>
                    <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#1B2E7A] leading-tight">
                        Homes that got smarter — without starting over.
                    </h2>
                </div>
                <div className="text-xs text-slate-500 max-w-xs">Placeholder stories, replaceable via CMS.</div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t, i) => (
                    <div key={i} className="bg-white rounded-3xl p-8 border border-slate-200 hover:border-[#1BB6F0]/60 transition-colors" data-testid={`testimonial-${i}`}>
                        <div className="flex items-center gap-1">
                            {Array.from({ length: t.rating }).map((_, j) => (
                                <Star key={j} className="w-4 h-4 fill-[#1BB6F0] text-[#1BB6F0]" />
                            ))}
                        </div>
                        <p className="mt-5 text-slate-700 leading-relaxed">"{t.text}"</p>
                        <div className="mt-6 pt-5 border-t border-slate-100">
                            <div className="font-semibold text-[#1B2E7A]">{t.name}</div>
                            <div className="text-xs text-slate-500 mt-0.5">{t.city} · {t.type}</div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
